import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Errors, UserService } from '../shared';

@Component({
  selector: 'account-recovery',
  templateUrl: './recovery.component.html'
})
export class RecoveryComponent implements OnInit {
  authType: String = '';
  title: String = '';
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef,
  ) {
    // use FormBuilder to create a form group
     this.toastr.setRootViewContainerRef(vcr);
    this.authForm = this.fb.group({
      'email': ['', Validators.required],
    });
  }

  ngOnInit() {
    this.route.url.subscribe(data => {
      // Get the last piece of the URL (it's either 'login' or 'register')
      this.authType = data[data.length - 1].path;
      // Set a title for the page accordingly
      this.title = (this.authType === 'login') ? 'Sign in' : 'Sign up';
      // add form control for username if this is the register page
      if (this.authType === 'register') {
        this.authForm.addControl('username', new FormControl());
      }
    });
  }


  submitForm() {
    this.isSubmitting = true;
    console.log(this.authForm.value.email)
    let data = {
      email: this.authForm.value.email
    }
    this.userService
      .forgetPassword(data)
      .subscribe(
      data => {
        this.toastr.success("Email and sms sent to you with details");
        var router = this.router;
        setTimeout(() => {
          router.navigateByUrl('/login');
        }, 3000);
      },
      err => {
        this.errors = err;
        this.isSubmitting = false;
        console.log(err);
        this.toastr.error(err);
       // this.toastr.error("You are not an authorized staff. This feature is valid for staff only");
      }
      );


  }
}



// WEBPACK FOOTER //
// ./src/app/auth/recovery.component.ts